// ساخته‌ی tools/marpele_knight_art.py — دستی ویرایش نکن.
/** ژست‌های آدمک به ترتیبِ MenchArt.Pose ِ اپ. */
export const KNIGHT_POSES = ["idle", "scared", "step1", "step2", "jump", "fallen", "cheer"] as const;

/**
 * جای آویزِ شیشه‌ی پادزهر روی کمربند: [x، y، زاویه] به پیکسلِ کادرِ آرت (y از بالا) — ژست‌ها ۱۸۰×۲۴۰ (p و g ساده،
 * kp و kg زره‌پوش)، قاب‌های ضربه ۳۶۰×۳۶۰ (sp و sg)؛ زاویه چرخشِ آدمک است (افتاده ±۹۰).
 */
export const POTION_AT = {
  p: [[54, 172.5, 0], [51.1, 172.5, 0], [56.2, 172.5, 0], [54.9, 173, 0], [64.7, 172.5, 0], [54.5, 162.4, 90], [65.5, 172.5, 0]],
  kp: [[54, 172.5, 0], [51.1, 172.5, 0], [56.2, 172.5, 0], [54.9, 173, 0], [64.7, 172.5, 0], [54.5, 162.4, 90], [65.5, 172.5, 0]],
  sp: [[157.8, 293, 0], [157.1, 291, 0], [153.2, 291, 0]],
  g: [[56.3, 172, 0], [57.3, 172.5, 0], [41.1, 157, 0], [43.1, 160, 0], [68.5, 154.5, 0], [118, 213.1, -90], [66.1, 174.5, 0]],
  kg: [[56.3, 172, 0], [57.3, 172.5, 0], [41.1, 157, 0], [43.1, 160, 0], [68.5, 154.5, 0], [118, 213.1, -90], [66.1, 174.5, 0]],
  sg: [[149.3, 279, 0], [152.9, 279, 0], [160.3, 279, 0]],
} as const;

/**
 * نوکِ شمشیر در سه قابِ ضربه (strike1..3)، کادرِ ۳۶۰×۳۶۰: آدمک جایی می‌ایستد که نوکِ قابِ ۳ روی سرِ مار بیفتد، و ردِ
 * شمشیر از نوکِ قابِ ۲ تا نوکِ قابِ ۳ کشیده می‌شود.
 */
export const STRIKE_TIP = {
  p: [[131.1, 222.2], [182.6, 98.0], [315.0, 346.8]],
  g: [[122.0, 206.1], [154.2, 102.6], [306.4, 334.5]],
} as const;
